function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.999 3.5V0h-2.5a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5H9.5a1.5 1.5 0 001.5-1.5V5H7.499a1.5 1.5 0 01-1.5-1.5zm1 0V.25L10.749 4h-3.25a.5.5 0 01-.5-.5zM0 3a1 1 0 011-1v8.5A2.5 2.5 0 003.5 13H9a1 1 0 01-1 1H3.556A3.556 3.556 0 010 10.444V3z",
  fill: "#8F90A6"
});

function SvgTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTemplate;